import { Link } from "react-router-dom";
import {
  services,
  CONTACT_PHONE,
  CONTACT_PHONE_TEL,
  CONTACT_EMAIL,
  WHATSAPP_URL,
  WHATSAPP_DISPLAY,
  SOCIAL_LINKEDIN_URL,
  SOCIAL_X_URL,
  SOCIAL_FACEBOOK_URL,
  SOCIAL_INSTAGRAM_URL,
  OFFICE_ADDRESSES,
  officeMapsUrl,
} from "../data/constants";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row g-5">
          <div className="col-lg-3">
            <Link to="/" className="d-inline-block mb-3">
              <img src={`${process.env.PUBLIC_URL || ""}/img/logo.png`} alt="Emicron" className="footer-logo" />
            </Link>
            <p>Leading system integration company based in Delhi, India. We design, implement, and manage robust IT infrastructure solutions.</p>
            <div className="mt-3">
              <a href={SOCIAL_LINKEDIN_URL} className="social-link" target="_blank" rel="noopener noreferrer" aria-label="Emicron on LinkedIn"><i className="bi bi-linkedin"></i></a>
              <a href={SOCIAL_X_URL} className="social-link" target="_blank" rel="noopener noreferrer" aria-label="Emicron on X"><i className="bi bi-twitter-x"></i></a>
              <a href={SOCIAL_FACEBOOK_URL} className="social-link" target="_blank" rel="noopener noreferrer" aria-label="Emicron on Facebook"><i className="bi bi-facebook"></i></a>
              <a href={SOCIAL_INSTAGRAM_URL} className="social-link" target="_blank" rel="noopener noreferrer" aria-label="Emicron on Instagram"><i className="bi bi-instagram"></i></a>
            </div>
          </div>
          <div className="col-6 col-lg-2">
            <div className="footer-heading">Company</div>
            <Link to="/" className="footer-link">Home</Link>
            <Link to="/about" className="footer-link">About Us</Link>
            <Link to="/blog" className="footer-link">Blog</Link>
            <Link to="/careers" className="footer-link">Careers</Link>
            <Link to="/services" className="footer-link">Solutions</Link>
            <Link to="/services" className="footer-link">Services</Link>
            <Link to="/service-desk" className="footer-link">Service Desk</Link>
            <Link to="/contact" className="footer-link">Contact Us</Link>
          </div>
          <div className="col-6 col-lg-3">
            <div className="footer-heading">Solutions</div>
            {services.slice(0, 4).map((s) => (
              <Link key={s.title} to="/services" className="footer-link">{s.title}</Link>
            ))}
          </div>
          <div className="col-lg-4">
            <div className="footer-heading">Contact Us</div>
            <div style={{ fontSize: "0.87rem", marginBottom: 10 }}>
              <i className="bi bi-telephone me-2" style={{ color: "var(--accent-green)" }}></i>
              <a className="footer-link footer-contact-link d-inline" href={`tel:${CONTACT_PHONE_TEL}`}>{CONTACT_PHONE}</a>
            </div>
            <div style={{ fontSize: "0.87rem", marginBottom: 10 }}>
              <i className="bi bi-whatsapp me-2" style={{ color: "var(--accent-green)" }}></i>
              <a className="footer-link footer-contact-link d-inline" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">{WHATSAPP_DISPLAY}</a>
            </div>
            <div style={{ fontSize: "0.87rem", marginBottom: 10 }}>
              <i className="bi bi-envelope me-2" style={{ color: "var(--accent-green)" }}></i>
              <a className="footer-link footer-contact-link d-inline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
            </div>
            {OFFICE_ADDRESSES.map((office) => (
              <div key={office.id} style={{ fontSize: "0.85rem", lineHeight: 1.6, marginBottom: 12 }}>
                <div style={{ color: "var(--accent-green)", fontWeight: 600, marginBottom: 4 }}>
                  <i className="bi bi-geo-alt me-1" aria-hidden="true" />
                  {office.label}
                </div>
                <a
                  className="footer-link footer-contact-link d-inline"
                  href={officeMapsUrl(office)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {office.lines.map((line, i) => (
                    <span key={line}>
                      {line}
                      {i < office.lines.length - 1 ? <br /> : null}
                    </span>
                  ))}
                </a>
              </div>
            ))}
          </div>
        </div>
        <div className="footer-divider d-flex flex-wrap justify-content-between align-items-center gap-2">
          <div className="footer-copy">© {new Date().getFullYear()} Emicron Techsolutions Pvt Ltd. All rights reserved.</div>
          <div className="footer-copy">Design by Elevates Team</div>
        </div>
      </div>
    </footer>
  );
}
